import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import PuestoService from "../../services/administracion/Puesto/PuestoServicec";
interface IcomboBoxSearch {
    search: string;
}

export const useComboPuestos = () => {
    const [dataComboPuesto, setDataComboPuesto] = useState<IComboBoxOption[]>([]);
    const [filter, setFilter] = useState<string>(
        "");

    const comboBoxPuestoRef = useRef<IComboBox>(null);
    const _openOptionComboPuesto = useCallback(
        () => comboBoxPuestoRef.current?.focus(true),
        []
    );
    const _onKeyUpSearchPuesto = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxPuestoRef.current?.focus(false);
        } else {
            _openOptionComboPuesto();
            let { value } = event?.target as HTMLInputElement;
            setFilter(value);
        }
    };
    const onClickOpenPuesto = () => {
        comboBoxPuestoRef.current?.focus(true);
    };

    const getComboPuesto = () => {
        PuestoService.getComboPuesto(filter).then((res) => {
            if (res.status === 200) {
                setDataComboPuesto(res.data.data.map((item: any) =>
                ({
                    key: item.id,
                    text: item.nombre
                })));
            }
        });
    };

    useEffect(() => {
        getComboPuesto();
    }, [filter]);


    return {
        onClickOpenPuesto,
        _onKeyUpSearchPuesto,
        dataComboPuesto,
        comboBoxPuestoRef,
    };
};
